window.contributionPercentageFormatter = function(value, row) {
    if (parseInt(value, 10) !== 0 && value !== '0,00') {
        if (parseInt(row.allow_discount, 10) === 1) {
            return value+'%';
        } else {
            return '<span class="text-decoration-line-through text-muted">'+value+'%'+'</span>';
        }
    }
};
